import React from 'react';

const imgIllustrator = '/icons/image-empty-search.png';
import './MaintenanceAccreditation.style.scss';

export const MaintenanceAccreditation = () => {
  return (
    <section
      className="maintenance-accreditation"
      data-testid="modal-maintenance-accreditation"
    >
      <header className="maintenance-accreditation__box-title">
        <h2 className="maintenance-accreditation__title">
          Comunicado Importante!
        </h2>
      </header>
      <article className="maintenance-accreditation__content">
        <div className="maintenance-accreditation__text-container">
          <h3 className="maintenance-accreditation__subtitle">
            Olá, parceiro! :)
          </h3>

          <p className="maintenance-accreditation__text">
            A gente está trabalhando para melhorar ainda mais a sua experiência
            e por isso os{' '}
            <strong>
              nossos sistemas estão em manutenção periódica pelas próximas 24h
            </strong>
            {'.'}
          </p>

          <p className="maintenance-accreditation__text">
            Por esse motivo, o acesso ao <strong>Credenciamento</strong> está
            temporariamente indisponível.
            <br />
            Por favor, tente mais tarde.
          </p>
          <p className="maintenance-accreditation__text">
            Contamos com a sua compreensão,
            <br />
            <strong>Equipe Alelo</strong>
          </p>
        </div>

        <div className="maintenance-accreditation__image">
          <img src={imgIllustrator} alt="Imagem ilustrativa de manutenção" />
        </div>
      </article>
    </section>
  );
};
